import ActivitiesSection from "../components/PageSections/KatalifeFree/ActivitiesSection";
import DownloadApp from "../components/DownloadApp";
import GrowthSection from "../components/PageSections/KatalifeFree/GrowthSection";
import Hero from "../components/Hero";
import ActivityProgressSection from "../components/PageSections/KatalifeFree/ActivityProgressSection";
import ShareFeedbackSection from "../components/PageSections/KatalifeFree/ShareFeedbackSection";
import SocialProofSection from "../components/PageSections/KatalifeFree/SocialProofSection";
import PainPointSection from "../components/PageSections/KatalifeFree/PainPointSection";

const HomePage = () => {
    return (
        <main>
            <Hero />
            {/* Social Proof 
            <SocialProofSection />
            */}
            <PainPointSection />
            <ActivitiesSection />
            <ShareFeedbackSection />
            <GrowthSection />
            <ActivityProgressSection />
            <DownloadApp />
        </main>
    );  
};

export default HomePage;
